import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import Navbar from "./components/navbar";
import Foot from "./components/footer";
import { Colors } from "./components/colors";
import TextInput from "./components/textBox";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { useCompanies } from "./contexts/CompanyContext";

const Companies = () => {
  const {companies, loading: companiesLoading, companyLogos, companyDisplayNames } = useCompanies();
  const [searchTerm, setSearchTerm] = useState("");
  const [resultCompanies, setResultCompanies] = useState(companies);
  const { t, i18n } = useTranslation();
  const [loaded, setLoaded ] = useState(false)
  const navigate = useNavigate();

  //initialize  data
  useEffect(() => {
    setResultCompanies(companies);
  }, [companiesLoading]);

  useEffect(() => {
    if (searchTerm == "") {
      setResultCompanies(companies);
    } else {
      filter(searchTerm);
    }
  }, [searchTerm]);

  function handleSearchChange(value) {
    setSearchTerm(value);
  }

const clear = () =>{
  setSearchTerm('')
}

  function filter(value) {
    const filteredCompanies = companies.filter((suggestion) =>
      value == suggestion.company_name
        ? null
        : suggestion.company_name.match(value.toLowerCase()),
    );
    const sorted = sortByProximity(filteredCompanies, value);
    setResultCompanies(sorted);
  }
  //sorting criteria
  function sortByProximity(array, targetLetter) {
    return array.sort((a, b) => {
      const target = targetLetter.toLowerCase().charCodeAt(0);
      const distanceA = Math.abs(a.company_name.charCodeAt(0) - target);
      const distanceB = Math.abs(b.company_name.charCodeAt(0) - target);

      return distanceA - distanceB;
    });
  }
  const inputStyle = {
    padding: "16px",
    fontSize: "16px",
    borderRadius: "20px",
    width: "90%",
  };
  return (
    <MainCol dir={i18n.dir()}>
      <Navbar />
      <FlexCol>
        <Page>
          <AboutHeader>{t("discover_companies")}</AboutHeader>
          <p>{t("companies_subtitle")}</p>
          <TextInput
            style={inputStyle}
            value={searchTerm}
            placeholder={t("search_a_company")}
            func={handleSearchChange}
          />
        </Page>
        {searchTerm.length== 0 && <AboutHeader>{t("popular_companies")}</AboutHeader>}
        {(resultCompanies.length > 0)? (
          <Page>
            {resultCompanies.slice(0, 20).map((company, index) => (
              <CompanyLink
                key={index}
                onClick={() => {
                  navigate(`/companies/${company.company_name}`);
                }}
              >
                {" "}
                <LogoWrapper>
                  <img
                    src={`https://img.logo.dev/${company.company_website}?token=pk_M0m3xPUmQQaKLD399NpbYw&size=64`}
                    alt={`${company.company_display_name} logo`}
                  />
                </LogoWrapper>
                {company.company_display_name}
              </CompanyLink>
            ))}{" "}
          </Page>
        ) : (
              (loaded && <Alert icon={<ShareIcon />} severity="info">
                <NotFoundTitle>
                  <AlertTitle>{t("404_company")} </AlertTitle> 
                  <FindOutLink onClick={clear}>{t("reset search")}</FindOutLink>
                </NotFoundTitle>
                {t("main_no_salaries_details")}{' '}
                <FindOutLink style={{display:"inline"}} href="/addsalary">{t("main_no_salaries_link")}</FindOutLink> {t("main_no_salaries_details_part_2")}
              </Alert>)
        )}
      </FlexCol>

      <Foot />
    </MainCol>
  );
};

export default Companies;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MainCol = styled(FlexCol)`
  justify-content: space-between;
  height: 100vh;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
const Header = styled(FlexRow)`
  justify-content: center;
  width: 60%;
  margin: 8px 0 8px 0;
  gap: 16px;
`;
const Role = styled(FlexRow)`
  padding: 8px;
  border: 1px solid ${Colors.lightGray};
  justify-content: space-between;
  margin: 8px;
  border-radius: 8px;
  padding: 32px 8px 32px 8px;
  font-size: 24px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s;

  &:hover {
    background-color: ${Colors.darkCyan};
    color: ${Colors.white};
  }
`;
const CompanyName = styled.h1`
  margin: 0;
  font-size: 72px;
`;

const LogoWrapper = styled.div`
  border: 1px solid ${Colors.lightGray};
  height: 64px;
  width: 64px;
  border-radius: 16px;
  overflow: hidden;
`;

const Page = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  border: 1px solid lightgray;
  width: 80%;
  border-radius: 8px;
  margin: 16px;
  justify-content: center;
  transition: opacity 0.5s;
`;
const AboutHeader = styled.h2`
  text-align: center;
  width: 100%;
`;
const RelatedPage = styled(FlexCol)`
  width: 25%;
  height: 100%;
  align-items: baseline;
`;

const CompanyLink = styled(FlexRow)`
  padding: 24px;
  cursor: pointer;
  align-items: left;
  justify-content: flex-start;
  font-size: 20px;
  gap: 12px;
  width: fit-content;
  &:hover {
    text-decoration: underline;
  }
`;

const NotFoundTitle = styled(FlexRow)`
  justify-content :space-between;
` 
const FindOutLink = styled.a`
  color: #0395ff;
  text-decoration: none;
  font-weight: 300;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #0458a2;
  }
`;